import { settings } from '../../../settings/settings-util'
let instance;

export default function getHistoryWatcher(settings) {
    if (!instance) {
        instance = new HistoryWatcher(settings);
    }
    return instance;
}

class HistoryWatcher {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._pending = false;
        this._responseTimer = null;

        this._pendingHandlers = [];
        this._receivedHandlers = [];
    }

    initialize() {
    }

    isPending() {
        return this._pending;
    }

    handleInput(input) {
        this.requestSent();
        return input;
    }

    handleMessage(message) {
        this.reset();
        return message;
    }

   

    getRequestHandler() {
        return { handle: this.handleInput.bind(this), 
            getReducer: function(){
                return i => i;
            }
        };
    }

    getResponseHandler() {
        return { process: this.handleMessage.bind(this), 
            getReducer: function(){
                return i => i;
            } };
    }

    registerHandlers(onPending, onReceived) {
        if (typeof onPending === 'function') {
            this._pendingHandlers.push(onPending);
        }
        if (typeof onReceived === 'function') {
            this._receivedHandlers.push(onReceived);
        }
        if (typeof onPending !== 'function' && typeof onReceived !== 'function') {
            throw new Error ("No pending or received handler provided! Why did you call subscribe()?");
        }
    }

    broadcastPending() {
        this._pendingHandlers.forEach(handler => handler());
    }

    broadcastReceived() {
        this._receivedHandlers.forEach(handler => handler());
    }

    requestSent() {
        if (this._responseTimer || this._pending) {
            return;
        }
        this.broadcastPending();
        this._pending = true;
        this._responseTimer = setTimeout(this.reset.bind(this), 
                            this._settings.AlmeAPI.ALME_API_REQUEST_TIMEOUT);
    }

    reset() {
        if (this._responseTimer) {
            clearTimeout(this._responseTimer);
            this._responseTimer = null;
        }
        this.broadcastReceived();
        this._pending = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/history-watcher/src/history-watcher.js